import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { validateImage } from '../../FirmSettings/utils/validateImage';

interface UploadAvatarParams {
  file: File;
}

const uploadAvatar = async ({ file }: UploadAvatarParams): Promise<string> => {
  await validateImage(file);

  const fileData = JSON.stringify({
    filename: window.encodeURIComponent(file.name),
    filetype: file.type,
  });

  const { signedUrl, imageFilename } = await authFetch(
    `/Adviser/AdviserAvatar/GetUploadToken?json=${fileData}`,
  );

  await fetch(signedUrl, { method: 'PUT', body: file });

  return imageFilename;
};

export const useUploadAvatarMutation = () => {
  return useMutation(uploadAvatar);
};
